// @ts-expect-error Could not find a declaration file for module
import FormattedDuration from 'I18n/components/FormattedDuration';
import ACThumbnailOverlay from 'academy-common-lib/components/card/ACThumbnailOverlay';
import { useLessonProgressById } from '../../userProgress';
import { useLesson, useShorts } from '../../../hooks/contentHooks';
import { WatchOnHubSpotAcademyLink } from './WatchOnHubSpotAcademyLink';
import { usageTracker } from '../../../utils/usageTracker';
import { getDisplayCategories } from 'academy-common-lib/utils/categories';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoProgressOverlay = ({
  contentId,
  isPublic = false,
  lessonId,
  shortId,
  language,
  link
}) => {
  var _lessonProgressById$c, _lesson$content, _ref, _lesson$subCategories, _ref2, _content$duration, _lesson$name;
  const {
    lessonProgressById
  } = useLessonProgressById(lessonId, isPublic);
  const {
    lesson
  } = useLesson(lessonId, language, isPublic);
  const {
    shortFormContent
  } = useShorts(shortId, isPublic);
  const contentProgress = lessonProgressById === null || lessonProgressById === void 0 || (_lessonProgressById$c = lessonProgressById.contentProgress) === null || _lessonProgressById$c === void 0 ? void 0 : _lessonProgressById$c.find(content => content.contentId === contentId);
  // @ts-expect-error each content type has an id field
  const content = lesson === null || lesson === void 0 || (_lesson$content = lesson.content) === null || _lesson$content === void 0 ? void 0 : _lesson$content.find(c => c.id === contentId);
  const categories = getDisplayCategories((_ref = (_lesson$subCategories = lesson === null || lesson === void 0 ? void 0 : lesson.subCategories.slice(0, 1)) !== null && _lesson$subCategories !== void 0 ? _lesson$subCategories : shortFormContent === null || shortFormContent === void 0 ? void 0 : shortFormContent.subCategories.slice(0, 1)) !== null && _ref !== void 0 ? _ref : []);
  const completed = (contentProgress === null || contentProgress === void 0 ? void 0 : contentProgress.progressType) === 'COMPLETED';
  // @ts-expect-error duration property may not exist on all content types
  const duration = (_ref2 = (_content$duration = content === null || content === void 0 ? void 0 : content.duration) !== null && _content$duration !== void 0 ? _content$duration : shortFormContent === null || shortFormContent === void 0 ? void 0 : shortFormContent.duration) !== null && _ref2 !== void 0 ? _ref2 : 0;
  return /*#__PURE__*/_jsx(ACThumbnailOverlay, {
    categories: categories,
    completed: completed,
    contentType: "ACADEMY_VIDEO",
    contentTypeName: (_lesson$name = lesson === null || lesson === void 0 ? void 0 : lesson.name) !== null && _lesson$name !== void 0 ? _lesson$name : shortFormContent === null || shortFormContent === void 0 ? void 0 : shortFormContent.name,
    duration: 1,
    footer: !completed && /*#__PURE__*/_jsx(FormattedDuration, {
      from: Date.now() - duration * 1000,
      to: Date.now(),
      type: "portalTz"
    }),
    remainingTime: completed ? 1 : 0,
    watermark: /*#__PURE__*/_jsx(WatchOnHubSpotAcademyLink, {
      href: link,
      onClick: () => {
        usageTracker.track('interaction', {
          action: 'watermark-link-to-academy-click',
          contentId,
          lessonId,
          shortId
        });
      }
    })
  });
};
export default VideoProgressOverlay;